export default "__VITE_ASSET__D$vvjiSU__"